import { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import AlertPopup from '../AlertPopup/AlertPopup';
import { HYPHEN, SOS_STATUS_KEYS } from '../../utilities/constants';
import dayjs from 'dayjs';
import { useSocket } from '../../context/SocketContext';

const SOSPopup = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { sosData } = useSocket();

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (
      sosData?.anomaly_type === 'sos' &&
      sosData?.ticket_status === SOS_STATUS_KEYS.PENDING
    ) {
      setOpen(true);
    }
  }, [sosData]);

  const formatDate = timestamp => {
    if (timestamp) {
      return dayjs(timestamp).format('MMM DD, YYYY, hh:mm A');
    } else {
      return HYPHEN;
    }
  };

  const handleGoToIssueClick = () => {
    navigate('/safety-and-anomaly-monitoring');
    handleClose();
  };

  const footerButtons = [
    <Button
      key="send"
      type="primary"
      htmlType="submit"
      onClick={handleGoToIssueClick}
    >
      Go to issue
    </Button>,
    <Button key="cancel" onClick={handleClose}>
      Cancel
    </Button>,
  ];

  const additionalFields = [
    {
      label: 'Trigger Type',
      value: sosData?.activationtype,
    },
    {
      label: 'Timestamp',
      value: formatDate(sosData?.event_timestamp),
    },
  ];

  return (
    <AlertPopup
      open={open}
      onClose={handleClose}
      title="SOS alert!"
      data={sosData}
      additionalFields={additionalFields}
      footerButtons={footerButtons}
    />
  );
};

export default SOSPopup;
